import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
import { PreviewModal } from '@hlj/hlj-components'
import styles from './style.module.less'
import { Link } from 'react-router'
import Store from './store'
const STATUS = {
  '0': 'btn_todo', //未完成
  '1': 'btn_audit', //待审核中
  '2': 'btn_error', //审核未通过
  '3': 'btn_finish' //已完成
}
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      location: {
        query: { id, title }
      }
    } = this.props
    this.store = new Store(id, title)
  }

  componentDidMount() {
    this.store.getData()
  }

  render() {
    const header = [<Link to="/localMerchant/home">首页</Link>, '犀牛学院']

    const {
      data: { prompt, guideVideo = {}, guideTask = {} },
      title
    } = this.store
    return (
      <HeaderView title={title} header={header}>
        <div className={styles.main}>
          <div className={styles.topTip}>
            <img
              className={styles.bg}
              src="https://qnm.hunliji.com/Fj7MM5P2RBjFlBlUR_dqp6_bz43A"
            />
            <div className={styles.tip}>
              <div>
                <img
                  src="https://qnm.hunliji.com/Fs01pa5PiN5ore5fDGJdkN68Q2cB"
                  width={24}
                  height={24}
                />
                <span>小犀的温馨提示：</span>
              </div>
              <p
                style={{ fontFamily: 'PingFangSC-Regular' }}
                dangerouslySetInnerHTML={{ __html: prompt }}
              />
            </div>
          </div>

          {guideVideo.videoPath && (
            <div className={styles.videoBox}>
              <p className={styles.title}>课程指导视频</p>
              <div className={styles.video}>
                <img className={styles.cover} src={guideVideo.videoCoverPath} />
                <div className={styles.shadow} />
                <img
                  src="//qnm.hunliji.com/FlsDe1K1ktYQ0U1WVys8zL5ghlkw"
                  style={{ width: 60, cursor: 'pointer', zIndex: 3 }}
                  className="center"
                  onClick={() => {
                    PreviewModal.open({
                      children: <video src={guideVideo.videoPath} controls />
                    })
                  }}
                />
                <p>{guideVideo.title}</p>
              </div>
            </div>
          )}

          <div className={styles.taskBox}>
            <p className={styles.title}>
              课程指导任务<span>
                {guideTask.completeCount}/{guideTask.totalCount}
              </span>
            </p>

            <div className={styles.inner}>
              {(guideTask.list || []).map(item => (
                <div className={styles.item}>
                  <div className={styles.b1}>
                    <div className={styles.b2}>
                      <img src={item.icon} />
                      <p className={styles.p1}>{item.taskName}</p>
                    </div>
                    <p className={styles.p2}>{item.taskDeputyCopywriter}</p>
                  </div>
                  <div
                    className={`${styles.btn} ${styles[STATUS[item.status]]}`}
                  >
                    <a
                      href={item.webRoute}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.buttonText}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </HeaderView>
    )
  }
}
